import React, {Component} from 'react';
import PropTypes from 'prop-types';
import Wrapper from '../../components/wrapper';
import {convertPipeToBrTag, convertKataToRome} from "../../utils";
import {WINDOW, DOCUMENT, IS_MOBILE} from '../../constants/environment'
import Cta from "../cta";
import CarNavigationLinkItem from "../car-navigation-link-item";
import './styles.css';
import BodyControl from "../../components/body";
import ImageLoader from '../../components/image-loader';

/**
 *  CarNavigation
 */
class CarNavigation extends Component {
  static propTypes = {
    containerId: PropTypes.string,
    containerClass: PropTypes.string,
    anchorPoint: PropTypes.string,
    anchorName: PropTypes.string,
    link: PropTypes.shape({
      pageName: PropTypes.string,
      pcText: PropTypes.string,
      mbText: PropTypes.string,
      href: PropTypes.string,
      targetBlank: PropTypes.bool,
    }),
    pageLinks: PropTypes.array,
    commonLinks: PropTypes.array,
    models: PropTypes.arrayOf(PropTypes.shape({
      modelName: PropTypes.string,
      modelNameJa: PropTypes.string,
      vehicleType: PropTypes.string,
      vehicleTabName: PropTypes.string,
      bodyTypes: PropTypes.arrayOf(PropTypes.shape({
        carTypeCode: PropTypes.string,
        carId: PropTypes.string,
        bodyTypeModel: PropTypes.string,
        bodyTypeCategory: PropTypes.string,
        bodyTypeFreeText: PropTypes.string,
        minPrice: PropTypes.number,
        number: PropTypes.number,
        grades:PropTypes.arrayOf(PropTypes.shape({
          specialCar: PropTypes.bool,
          specialCarTabName: PropTypes.string,
          welfareCar: PropTypes.bool,
          weflareCarTabName: PropTypes.string,
          welfareCarTypeCategory: PropTypes.string,
          gradeId: PropTypes.string,
          gradeName: PropTypes.string,
          gradeFreeText: PropTypes.string,
          specialCarDefaultGrade: PropTypes.bool,
          welfareCarDefaultGrade: PropTypes.bool,
          carLineupUrl: PropTypes.string,
          minPrice: PropTypes.number
        }))
      }))
    })),
    onChange: PropTypes.func,
    parentIndex: PropTypes.number
  };
  static defaultProps = {
    containerId: null,
    containerClass: null,
    anchorPoint: null,
    anchorName: null,
    link: null,
    pageLinks: null,
    commonLinks: null,
    models: null
  };

  constructor(props) {
    super();
    this.props = props;
    this.state = {
      vehicle: 'Passenger Car',
      view: 'Grid',
      models: null
    };
    this.onChangeVehicle = this.onChangeVehicle.bind(this);

    this.vehicleIntervalId;

  }

  componentDidMount() {
    //console.log('[DidMount]', this.state);

    this.setState({
      vehicle: 'Passenger Car',
      view: 'Grid',
      models: null
    });

    // setTimeout(this.applyFilter, 100);
    this.applyFilter();
  };

  render() {
    const {
      containerId,
      containerClass,
      anchorPoint,
      anchorName,
      link,
      pageLinks,
      commonLinks,
      models
    } = this.props;

    //
    return (
      <Wrapper
        containerId={containerId}
        containerClass={containerClass}
        anchorPoint={anchorPoint}
        anchorName={anchorName}
      >
        <section className="CarNavigation" ref="CarNavigation">
          <div className="CarNavigation__container">
          {(() => {
            const vehicles = this.getVehicleTabNames(models);

            if(vehicles){
              return(
                <form className={"CarNavigation__VehiclesForm"} name="vehiclesFilter" ref="vehiclesFilter">
                  <ul className="CarNavigation__VehiclesForm__List">
                  {(() => {
                    if(vehicles['Passenger Car'] && Array.isArray(vehicles['Passenger Car'])){
                      return(
                        vehicles['Passenger Car'].map((name, index) => {
                          {
                            return(
                              <li className="CarNavigation__VehiclesForm__List__Item" key={'PassengerCar' + index}><label className="CarNavigation__VehiclesForm__List__Item__Label"><input className="CarNavigation__VehiclesForm__List__Item__Label__Radio" type="radio" name="vehicle" value="Passenger Car"  checked={this.state.vehicle === 'Passenger Car'}  onChange={this.onChangeVehicle} /><span className="CarNavigation__VehiclesForm__List__Item__Label__Text">{name}</span></label></li>
                            );
                          }
                        })
                      )
                    }
                  })()}
                  {(() => {
                    if(vehicles['Light Car'] && Array.isArray(vehicles['Light Car'])){
                      return(
                        vehicles['Light Car'].map((name, index) => {
                          {
                            return(
                              <li className="CarNavigation__VehiclesForm__List__Item" key={'LightCar' + index}><label className="CarNavigation__VehiclesForm__List__Item__Label"><input className="CarNavigation__VehiclesForm__List__Item__Label__Radio" type="radio" name="vehicle" value="Light Car"  checked={this.state.vehicle === 'Light Car'}  onChange={this.onChangeVehicle} /><span className="CarNavigation__VehiclesForm__List__Item__Label__Text">{name}</span></label></li>
                            );
                          }
                        })
                      )
                    }
                  })()}
                  {(() => {
                    if(vehicles['Special Car'] && Array.isArray(vehicles['Special Car'])){
                      return(
                        vehicles['Special Car'].map((name, index) => {
                          {
                            return(
                              <li className="CarNavigation__VehiclesForm__List__Item" key={'SpecialCar' + index}><label className="CarNavigation__VehiclesForm__List__Item__Label"><input className="CarNavigation__VehiclesForm__List__Item__Label__Radio" type="radio" name="vehicle" value="Special Car"  checked={this.state.vehicle === 'Special Car'}  onChange={this.onChangeVehicle} /><span className="CarNavigation__VehiclesForm__List__Item__Label__Text">{name}</span></label></li>
                            );
                          }
                        })
                      )
                    }
                  })()}
                  {(() => {
                    if(vehicles['Commercial Car'] && Array.isArray(vehicles['Commercial Car'])){
                      return(
                        vehicles['Commercial Car'].map((name, index) => {
                          {
                            return(
                              <li className="CarNavigation__VehiclesForm__List__Item" key={'CommercialCar' + index}><label className="CarNavigation__VehiclesForm__List__Item__Label"><input className="CarNavigation__VehiclesForm__List__Item__Label__Radio" type="radio" name="vehicle" value="Commercial Car"  checked={this.state.vehicle === 'Commercial Car'}  onChange={this.onChangeVehicle} /><span className="CarNavigation__VehiclesForm__List__Item__Label__Text">{name}</span></label></li>
                            );
                          }
                        })
                      )
                    }
                  })()}
                  {(() => {
                    if(vehicles['Welfare Car'] && Array.isArray(vehicles['Welfare Car'])){
                      return(
                        vehicles['Welfare Car'].map((name, index) => {
                          {
                            return(
                              <li className="CarNavigation__VehiclesForm__List__Item" key={index}><label className="CarNavigation__VehiclesForm__List__Item__Label"><input className="CarNavigation__VehiclesForm__List__Item__Label__Radio" type="radio" name="vehicle" value="Welfare Car"  checked={this.state.vehicle === 'Welfare Car'}  onChange={this.onChangeVehicle} /><span className="CarNavigation__VehiclesForm__List__Item__Label__Text">{name}</span></label></li>
                            );
                          }
                        })
                      )
                    }
                  })()}
                  </ul>
                </form>
              )
            }
          })()}

          {(() => {
            if(this.state.models){
              return (
                <div className={"CarNavigation__Cars CarNavigation__Cars--" + this.state.view}
                      ref="cars"
                      onTransitionEnd={(e)=> {
                        e.currentTarget.classList.remove('fadein');
                        e.currentTarget.style.opacity = "";
                      }}
                >
                  <ul className="CarNavigation__Cars__Body">
                    {(() => {

                      let vehicles = [];
                      let links = [];
                      let currentNumber = 1;
                      let maxNumber = this.getVehiclesMaxNumber();
                      let listItems = [];

                      // make list items
                      while(currentNumber <= maxNumber){
                        vehicles = this.getTargetVehicles(currentNumber);
                        links = this.getTargetPageLinks(currentNumber);
                        if(vehicles && vehicles.length > 0){
                          vehicles.map((vehicle, index) => {
                            listItems.push(
                              // <li className="CarNavigation__Cars__Body__Item" key={'vehicle' + currentNumber + '_' + index}>
                              // <li className="CarNavigation__Cars__Body__Item" key={vehicle.category + '_' + currentNumber + '_' + index}>
                              <li className={"CarNavigation__Cars__Body__Item " + 'vehicle' + currentNumber + '_' + Math.floor(Math.random() * 1000)} key={'vehicle' + currentNumber + '_' + Math.floor(Math.random() * 1000)}>
                                <a
                                  href={vehicle.url}
                                  className={"CarNavigation__Cars__Body__Item__Link" + (!vehicle.url ? ' CarNavigation__Cars__Body__Item__Link--disabled' : '')}
                                  onClick={this.onClickCarLink}
                                  data-car_id={vehicle.carId}
                                  data-grade_id={vehicle.gradeId}
                                  disabled={!vehicle.url ? 'disabled' : null}
                                >

                                  <ImageLoader
                                    width={'90%'}
                                    ratio={0.5}
                                    src={vehicle.src}
                                    backgroundSize={'contain'}
                                    key={'vehicle' + currentNumber + '_' + Math.floor(Math.random() * 1000)}
                                  />

                                  {/*<div className="CarNavigation__Cars__Body__Item__Link__dd">*/}
                                    {/*<span style={{backgroundImage: 'url(' + vehicle.src + ')'}} />*/}
                                  {/*</div>*/}

                                  {/*<div className="CarNavigation__Cars__Body__Item__Link__dd">*/}
                                    {/*<img src={vehicle.src} alt={vehicle.name} className="CarNavigation__Cars__Body__Item__Link__image" />*/}
                                  {/*</div>*/}

                                  <div className="CarNavigation__Cars__Body__Item__Link__dt">
                                    {vehicle.name ? <span className="CarNavigation__Cars__Body__Item__Link__title" dangerouslySetInnerHTML={{__html: convertPipeToBrTag(vehicle.name)}} /> : null}
                                    {vehicle.category ? <span className="CarNavigation__Cars__Body__Item__Link__category">{vehicle.category}</span> : null}
                                    {vehicle.price ? <span className="CarNavigation__Cars__Body__Item__Link__price">¥{Number(vehicle.price).toLocaleString()}〜（消費税込）</span> : null}
                                    {vehicle.freeText ? <span className="CarNavigation__Cars__Body__Item__Link__free-text">{vehicle.freeText}</span> : null}
                                  </div>
                                </a>
                              </li>
                            );
                          })
                        }
                        else if(links && links.length > 0){
                          links.map((link, index) => {
                            const props = Object.assign({}, link.props);
                            listItems.push(
                              <li className="CarNavigation__Cars__Body__Item" key={'link' + currentNumber + '_' + index}>
                                <CarNavigationLinkItem
                                  {...props}
                                />
                              </li>
                            );
                          })
                        }
                        else{
                          if(this.state.vehicle.match(/Passenger Car|Light Car|Commercial Car/)){
                            listItems.push(
                              <li className="CarNavigation__Cars__Body__Item CarNavigation__Cars__Body__Item--blank" key={'blank' + currentNumber}>
                              </li>
                            )
                          }
                        }
                        currentNumber++;
                      }
                      return listItems;
                    })()}
                  </ul>
                </div>
              )
            }
          })()}

          {(() => {
            if(commonLinks){
              return (
                <div className="CarNavigation__commonLinks">
                  <ul className="CarNavigation__commonLinks__list">
                  {
                    commonLinks.map((data, index) => {
                      const props = Object.assign({}, data.props);
                      return (
                        <li className="CarNavigation__commonLinks__list__item" key={index}>
                          <Cta
                            {...props}
                          />
                        </li>
                      );
                    })
                  }
                  </ul>
                </div>
              )
            }
          })()}
          </div>
        </section>
      </Wrapper>
    )
  }

  onChangeVehicle = (e) => {
    this.setState({
      vehicle: e.target.value,
    });

    this.applyFilter();

    if(IS_MOBILE){
      this.slideVehicleNavi();
      this.props.onChange(this.props.parentIndex);
    }
  };

  slideVehicleNavi = () => {
    const checkedRadio = this.refs.vehiclesFilter.querySelector("input[type='radio']:checked");
    const current = checkedRadio.parentNode.parentNode;
    const parent = current.parentNode;
    const currentRect = current.getBoundingClientRect();
    const parentRect = parent.getBoundingClientRect();

    let children = parent.children;
    let child;
    let currentLeft = 0;
    let totalWidth = 0;
    for(let i = 0; i < parent.children.length; i++){
      child = parent.children[i];
      totalWidth += child.getBoundingClientRect().width;
    }
    for(let i = 0; i < parent.children.length; i++){
      child = parent.children[i];
      if(child === current){
        break;
      }
      currentLeft += child.getBoundingClientRect().width;
    }

    let scrollLeft = currentLeft - parentRect.width / 2 + currentRect.width / 2;
    scrollLeft = scrollLeft < 0 ? 0 : scrollLeft;

    if(totalWidth - scrollLeft < parentRect.width){
      scrollLeft = totalWidth - parentRect.width
    }

    scrollLeft = Math.floor(scrollLeft);

    clearInterval(this.vehicleIntervalId);
    this.vehicleIntervalId = setInterval(
      () => {
        if(scrollLeft - parent.scrollLeft < 0){
          parent.scrollLeft += Math.ceil((scrollLeft - parent.scrollLeft) * -0.1) * -1;
        }
        else{
          parent.scrollLeft += Math.ceil((scrollLeft - parent.scrollLeft) * 0.1);
        }

        if(Math.abs(scrollLeft - parent.scrollLeft) < 1){
          parent.scrollLeft = scrollLeft;
          clearInterval(this.vehicleIntervalId);
        }
        // console.log(parent.scrollLeft, scrollLeft);
      },
    1000 / 60);
  };

  onClickCarLink = (e) => {

    let date = new Date();
    date.setTime(date.getTime() + 24 * 60 * 60 * 1000); //24h
    let expires = date.toGMTString();

    if(DOCUMENT){
      if(e.currentTarget.dataset.car_id){
        DOCUMENT.cookie = "carId=" + e.currentTarget.dataset.car_id + ";expires=" + expires + ";path=/";
      }
      if(e.currentTarget.dataset.grade_id){
        DOCUMENT.cookie = "gradeId=" + e.currentTarget.dataset.grade_id + ";expires=" + expires + ";path=/";
      }
    }

    if(WINDOW){
      WINDOW.location.href = e.currentTarget.href;
    }

    e.preventDefault();
    return false;
  };

  getVehicleTabNames = (models) => {
    let vehicles = {
      'Passenger Car':[],
      'Light Car':[],
      'Special Car':[],
      'Commercial Car':[],
      'Welfare Car':[]
    };

    if(models){
      models.map((model, index) => {
        if(model.vehicleType === 'Passenger Car' && model.vehicleTabName !== ''){
          vehicles['Passenger Car'].push(model.vehicleTabName);
        }
        else if(model.vehicleType === 'Light Car' && model.vehicleTabName !== ''){
          vehicles['Light Car'].push(model.vehicleTabName);
        }
        else if(model.vehicleType === 'Commercial Car' && model.vehicleTabName !== ''){
          vehicles['Commercial Car'].push(model.vehicleTabName);
        }

        if(model.bodyTypes && Array.isArray(model.bodyTypes)){
          model.bodyTypes.map((bodyType, index) => {
            if(bodyType.grades && Array.isArray(bodyType.grades)){
              bodyType.grades.map((grade, index) => {
                if(grade.specialCar === true && grade.specialCarTabName && grade.specialCarTabName !== ''){
                  vehicles['Special Car'].push(grade.specialCarTabName);
                }
                else if(grade.welfareCar === true && grade.welfareCarTabName && grade.welfareCarTabName !== ''){
                  vehicles['Welfare Car'].push(grade.welfareCarTabName);
                }
              });
            }
          });
        }

      });
    }

    for (let vehicleType in vehicles) {
      if (vehicles.hasOwnProperty(vehicleType)) {
        // 重複を削除
        vehicles[vehicleType] = vehicles[vehicleType].filter((x, i, self) => self.indexOf(x) === i);
      }
    }

    return vehicles;

  };

  applyFilter = () => {
    const vehicles = this.refs.vehiclesFilter;

    if(this.refs.cars != null && this.refs.cars.classList != null){
      this.refs.cars.classList.remove('fadein');
      this.refs.cars.style.opacity = 0;
      setTimeout(
        () => {
          this.refs.cars.classList.add('fadein');
          this.refs.cars.style.opacity = 1;
        },
      1);
    }

    let currentVehicleType = '';
    for(let i = 0; i < vehicles.vehicle.length; i++){
      if (vehicles.vehicle[i].checked) {
        currentVehicleType = vehicles.vehicle[i].value;
        break;
      }
    }

    let models = JSON.parse(JSON.stringify(this.props.models));
    if(models && models.length > 0){
      let i = models.length;
      loopModel:while(i--) {
        //車種（Passenger Car/Light Car/Commercial Car）
        if(currentVehicleType.match(/Passenger Car|Light Car|Commercial Car/) && models[i].vehicleType !== currentVehicleType){
          models.splice(i, 1);
          continue loopModel;
        }

        if(currentVehicleType.match(/Passenger Car|Light Car|Commercial Car/)){
          let bodyTypes = models[i].bodyTypes;
          if(bodyTypes && bodyTypes.length > 0){
            let j = bodyTypes.length;
            loopBodyType:while(j--) {
              let bodyType = bodyTypes[j];

              if(bodyType.grades && Array.isArray(bodyType.grades) && bodyType.grades.length > 0){
                let k = bodyType.grades.length;
                loopGrade:while(k--) {
                  let grade = bodyType.grades[k];
                  if(grade.welfareCar === true){
                    bodyTypes.splice(j, 1);
                    continue loopBodyType;
                  }
                  if(grade.specialCar === true){
                    bodyTypes.splice(j, 1);
                    continue loopBodyType;
                  }
                }
              }
            }
          }
        }

        if(true) {
          let bodyTypes = models[i].bodyTypes;
          if(bodyTypes && bodyTypes.length > 0){
            let j = bodyTypes.length;
            loopBodyType:while(j--) {
              let bodyType = bodyTypes[j];
              if(bodyType.grades && Array.isArray(bodyType.grades) && bodyType.grades.length > 0){
                let k = bodyType.grades.length;
                loopGrade:while(k--) {
                  let grade = bodyType.grades[k];
                  //特別仕様車チェック
                  if(currentVehicleType.match(/Special Car/) && (grade === null || grade.specialCar !== true || grade.specialCarDefaultGrade !== true)){
                    bodyType.grades.splice(k, 1);
                    continue loopGrade;
                  }
                  //福祉車両チェック
                  else if(currentVehicleType.match(/Welfare Car/) && (grade === null || grade.welfareCar !== true || grade.welfareCarDefaultGrade !== true)){
                    bodyType.grades.splice(k, 1);
                    continue loopGrade;
                  }
                }
                if(bodyType.grades.length === 0){
                  delete bodyType.grades;
                }
              }
              if(currentVehicleType.match(/Special Car/) || currentVehicleType.match(/Welfare Car/)){
                if(!bodyType.grades || bodyType.grades.length === 0){
                  bodyTypes.splice(j, 1);
                  continue loopBodyType;
                }
              }
            }
          }
        }
      }
    }

    this.setState({
      models: models
    });

    setTimeout(
      this.setNamePlateHeight,
    200);
  };

  getTargetVehicles = (targetNumber) => {
    let models = this.state.models;
    let vehicles = [];

    //特別仕様車・福祉車両はnumberを参照せず順番通りに取得する
    if(this.state.vehicle.match(/Special Car|Welfare Car/)){
      let targetIndex = targetNumber - 1;
      let bodyTypeCount = 0;
      models.map((model, index) => {
        if(model.bodyTypes){
          model.bodyTypes.map((bodyType, index) => {
            if(bodyTypeCount === targetIndex){

              let carName, carCategory, carPrice, carFreeText, carImageSrc, carLinkUrl, carId, carGradeId;

              if(bodyType.grades){
                bodyType.grades.map((grade, index) => {
                  switch(this.state.vehicle){
                    case 'Special Car':
                      carName = grade && grade.gradeName ? grade.gradeName : null;
                      carCategory = bodyType.bodyTypeCategory ? bodyType.bodyTypeCategory : null;
                      carPrice = grade && grade.minPrice ? grade.minPrice : null;
                      carImageSrc = '/globalassets/assets/cars/' + this.format(model.modelName) + '/' + this.format(bodyType.carId) + '/' + this.format(bodyType.carTypeCode) + '/' + this.format(grade.gradeId) + '/common/' + this.format(grade.gradeId) + '_default_s.png';
                      // carImageSrc = '/assets-dev/MX5_SoulRed.png';
                      carLinkUrl = grade.carLineupUrl != null && grade.carLineupUrl !== '' ? grade.carLineupUrl : '';
                      carFreeText = grade.gradeFreeText ? grade.gradeFreeText : null;
                      carId = bodyType.carId ? bodyType.carId : null;
                      carGradeId = grade.gradeId ? grade.gradeId : null;
                      break;
                    case 'Welfare Car':
                      carName = grade && grade.gradeName ? grade.gradeName : null;
                      carCategory = grade && grade.welfareCarTypeCategory ? grade.welfareCarTypeCategory : null;
                      carPrice = null;
                      carImageSrc = '/globalassets/assets/cars/' + this.format(model.modelName) + '/' + this.format(bodyType.carId) + '/' + this.format(bodyType.carTypeCode) + '/' + this.format(grade.gradeId) + '/common/welfare_' + this.format(grade.gradeId) + '_default_s.png';
                      // carImageSrc = '/assets-dev/Mazda6_SonicSilver.png';
                      carLinkUrl = grade.carLineupUrl != null && grade.carLineupUrl !== '' ? grade.carLineupUrl : '';
                      carFreeText = grade.gradeFreeText ? grade.gradeFreeText : null;
                      carId = bodyType.carId ? bodyType.carId : null;
                      carGradeId = grade.gradeId ? grade.gradeId : null;
                      break;
                  }

                  vehicles.push({
                    name: carName,
                    category: carCategory,
                    price: carPrice,
                    freeText: carFreeText,
                    src: carImageSrc,
                    url: carLinkUrl,
                    carId: carId,
                    gradeId: carGradeId
                  });
                })
              }
            }
            bodyTypeCount++;
          })
        }
      })
      return vehicles;
    }

    //乗用車／軽自動車／商用車・特装車
    models.map((model, index) => {
      if(model.bodyTypes){
        model.bodyTypes.map((bodyType, index) => {
          if(bodyType.number != null && bodyType.number === targetNumber){

            let carName, carCategory, carPrice, carFreeText, carImageSrc, carLinkUrl, carId, carGradeId;

            if(this.state.vehicle.match(/Passenger Car|Light Car|Commercial Car/)){
              switch(this.state.vehicle){
                case 'Passenger Car':
                case 'Light Car':
                  carName = bodyType.bodyTypeModel ? bodyType.bodyTypeModel : null;
                  carName = carName ? carName : bodyType.carId;
                  carCategory = bodyType.bodyTypeCategory ? bodyType.bodyTypeCategory : null;
                  carPrice = bodyType.minPrice ? bodyType.minPrice : null;
                  carImageSrc = '/globalassets/assets/cars/' + this.format(model.modelName) + '/' + this.format(bodyType.carId) + '/' + this.format(bodyType.carTypeCode) + '/common/default_s.png';
                  // carImageSrc = '/assets-dev/Mazda2_DynamicBlue.png';
                  carLinkUrl = '/cars/' + this.format(model.modelName).replace('roadsterrf', 'roadster-rf') + '/?car_id=' + this.format(bodyType.carId);
                  carFreeText = bodyType.bodyTypeFreeText ? bodyType.bodyTypeFreeText : null;
                  carId = bodyType.carId ? bodyType.carId : null;
                  carGradeId = null;
                  break;
                case 'Commercial Car':
                  carName = bodyType.bodyTypeModel ? bodyType.bodyTypeModel : null;
                  carName = carName ? carName : bodyType.carId;
                  carCategory = bodyType.bodyTypeCategory ? bodyType.bodyTypeCategory : null;
                  carPrice = null;
                  carImageSrc = '/globalassets/assets/cars/' + this.format(model.modelName) + '/' + this.format(bodyType.carId) + '/' + this.format(bodyType.carTypeCode) + '/common/commercial_default_s.png';
                  // carImageSrc = '/assets-dev/Mazda3_MachineGrey.png';
                  carLinkUrl = '/cars/' + this.format(model.modelName).replace('roadsterrf', 'roadster-rf') + '/';
                  carFreeText = bodyType.bodyTypeFreeText ? bodyType.bodyTypeFreeText : null;
                  carId = bodyType.carId ? bodyType.carId : null;
                  carGradeId = null;
                  break;
              }

              vehicles.push({
                name: carName,
                category: carCategory,
                price: carPrice,
                freeText: carFreeText,
                src: carImageSrc,
                url: carLinkUrl,
                carId: carId,
                gradeId: carGradeId
              });

            }
            else if(this.state.vehicle.match(/Special Car|Welfare Car/)){
              if(bodyType.grades){
                bodyType.grades.map((grade, index) => {
                  switch(this.state.vehicle){
                    case 'Special Car':
                      carName = grade && grade.gradeName ? grade.gradeName : null;
                      carCategory = bodyType.bodyTypeCategory ? bodyType.bodyTypeCategory : null;
                      carPrice = grade && grade.minPrice ? grade.minPrice : null;
                      carImageSrc = '/globalassets/assets/cars/' + this.format(model.modelName) + '/' + this.format(bodyType.carId) + '/' + this.format(bodyType.carTypeCode) + '/' + this.format(grade.gradeId) + '/common/' + this.format(grade.gradeId) + '_default_s.png';
                      // carImageSrc = '/assets-dev/MX5_SoulRed.png';
                      carLinkUrl = grade.carLineupUrl != null && grade.carLineupUrl !== '' ? grade.carLineupUrl : '';
                      carFreeText = grade.gradeFreeText ? grade.gradeFreeText : null;
                      carId = bodyType.carId ? bodyType.carId : null;
                      carGradeId = grade.gradeId ? grade.gradeId : null;
                      break;
                    case 'Welfare Car':
                      carName = grade && grade.gradeName ? grade.gradeName : null;
                      carCategory = grade && grade.welfareCarTypeCategory ? grade.welfareCarTypeCategory : null;
                      carPrice = null;
                      carImageSrc = '/globalassets/assets/cars/' + this.format(model.modelName) + '/' + this.format(bodyType.carId) + '/' + this.format(bodyType.carTypeCode) + '/' + this.format(grade.gradeId) + '/common/welfare_' + this.format(grade.gradeId) + '_default_s.png';
                      // carImageSrc = '/assets-dev/Mazda6_SonicSilver.png';
                      carLinkUrl = grade.carLineupUrl != null && grade.carLineupUrl !== '' ? grade.carLineupUrl : '';
                      carFreeText = grade.gradeFreeText ? grade.gradeFreeText : null;
                      carId = bodyType.carId ? bodyType.carId : null;
                      carGradeId = grade.gradeId ? grade.gradeId : null;
                      break;
                  }

                  vehicles.push({
                    name: carName,
                    category: carCategory,
                    price: carPrice,
                    freeText: carFreeText,
                    src: carImageSrc,
                    url: carLinkUrl,
                    carId: carId,
                    gradeId: carGradeId
                  });
                })
              }
            }
          }
        })
      }
    });

    return vehicles;
  };

  getTargetPageLinks = (targetNumber) => {
    let links = [];
    let pageLinks = this.props.pageLinks;

    if(pageLinks){
      pageLinks.map((pageLink, index) => {
        if(this.state.vehicle === pageLink.props.type && pageLink.props.number != null && pageLink.props.number === targetNumber){
          links.push(pageLink);
        }
      })
    }

    return links;
  };

  getVehiclesMaxNumber = () => {
    let models = this.state.models;
    let pageLinks = this.props.pageLinks;
    let maxNumber = 0;

    if(models){
      models.map((model, index) => {
        if(model.bodyTypes){
          model.bodyTypes.map((bodyType, index) => {
            if(bodyType.number != null){
              maxNumber = Math.max(maxNumber, Number(bodyType.number));
            }
          })
        }
      });
    }

    if(pageLinks){
      pageLinks.map((pageLink, index) => {
        if(this.state.vehicle === pageLink.props.type && pageLink.props.number != null){
          maxNumber = Math.max(maxNumber, Number(pageLink.props.number));
        }
      });
    }

    //特別仕様車・福祉車両の場合はnumberを参照せずに総数を参照する（大きい方を採用する）
    if(this.state.vehicle.match(/Special Car|Welfare Car/)){
      if(models){
        models.map((model, index) => {
          if(model.bodyTypes){
            model.bodyTypes.map((bodyType, index) => {
              maxNumber = Math.max(maxNumber, Number(bodyType.number));
            });
          }
        });
      }
      if(pageLinks){
        pageLinks.map((pageLink, index) => {
          if(this.state.vehicle === pageLink.props.type){
            maxNumber = Math.max(maxNumber, Number(pageLink.props.number));
          }
        });
      }
    }

    return maxNumber;
  };

  onResize = (e) => {
    this.setNamePlateHeight();
  };

  setNamePlateHeight = () => {
    let cars;
    let items, itemsNum;
    let namePlates, namePlate;
    let namePlatesNum;
    let heights = [];
    let maxHeight = 0;
    let columnNum;

    cars = this.refs.cars;

    if(!WINDOW || !cars){
      return false;
    }

    columnNum = IS_MOBILE ? 2 : 5;

    items = cars.querySelectorAll('.CarNavigation__Cars__Body__Item');

    if(!items){
      return false;
    }

    //モバイルでは空白のセルを除外する
    if(IS_MOBILE){
      let cleanItems = [];
      let i = items.length;
      for(let i = 0; i < items.length; i++){
        let item = items[i];
        if(!item.classList.contains('CarNavigation__Cars__Body__Item--blank')){
          cleanItems.push(item);
        }
      }
      items = cleanItems;
    }

    itemsNum = items.length;

    //全ネームプレートの高さ取得＆初期化
    for(let i = 0; i < itemsNum; i++){
      namePlate = items[i].querySelector('.CarNavigation__Cars__Body__Item__Link__title');
      if(namePlate){
        namePlate.style.height = '';  //リサイズイベントに対応するために初期化
        // heights[i] = namePlate.getBoundingClientRect().height;
        heights[i] = namePlate.offsetHeight;
      }
      else{
        heights[i] = null;
      }
    }

    if(this.state.view !== 'Grid'){
      return false;
    }

    //行ごとのネームプレートの高さを最大値に揃える
    for(let i = 0; i < itemsNum; i++){
      if(i % columnNum === 0){
        maxHeight = 0;
      }
      if(heights[i] != null && heights[i] > maxHeight){
        maxHeight = heights[i];
      }

      let j = i;
      loop:do{
        heights[j] = heights[j] == null ? null : maxHeight;
        if(j % columnNum === 0){
          break loop;
        }
      }while(j--);

    }

    //ネームプレートの高さをセットする
    for(let i = 0; i < itemsNum; i++){
      namePlate = items[i].querySelector('.CarNavigation__Cars__Body__Item__Link__title');
      // console.log(i, heights[i]);
      if(namePlate){
        namePlate.style.height = heights[i] + 'px';
      }
    }

  };

  format = (str) => {
    return convertKataToRome(String(str).toLowerCase().split(' ').join('-'));
  };

  inArray = (array, val) => {
    if(!Array.isArray(array)){
      return false;
    }
    if(array.indexOf(val) >= 0){
      return true;
    }
    else{
      return false;
    }
  };

}

export default CarNavigation;



// WEBPACK FOOTER //
// ./src/containers/car-navigation/index.jsx